import * as z from 'zod';

/** Legacy `HrFineComponent` form: fine type, amount, date and reason. */
export const fineFormSchema = z.object({
  FineType: z.string().min(1, { message: 'ERR_MSG_REQUIRED' }),
  FineAmount: z.coerce
    .number({ error: 'ERR_MSG_REQUIRED' })
    .int({ message: 'FINE_AMOUNT_WHOLE_NUMBER' })
    .min(1, { message: 'VALID_POSITIVE_NUMBER' }),
  Date: z.string().min(1, { message: 'DATE_REQUIRED' }),
  Reason: z
    .string()
    .min(1, { message: 'REASON_REQUIRED' })
    .max(100, { message: 'REASON_TOO_LONG' }),
});

export type FineFormValues = z.infer<typeof fineFormSchema>;
